<template>
  <v-container>
    <div class="mt-2">
      <AppSearchBox :value.sync="search" clearable />
    </div>

    <v-card color="primary" class="fipa--header mt-2" />

    <SearchTemplateHorses
      :items="horses"
      :hide-default-header="$vuetify.breakpoint.smAndDown"
      :loading="$apollo.queries.horses.loading"
    />
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import SearchTemplateHorses from "@/components/table_templates/Horses.vue";
import AppSearchBox from "../AppSearchBox.vue";

export default defineComponent({
  name: "AdminHorses",
  components: {
    SearchTemplateHorses,
    AppSearchBox
  },
  data() {
    return {
      horses: [],
      search: null
    };
  },
  apollo: {
    horses: {
      query: gql`
        query horses($keyword: String) {
          horses(keyword: $keyword) {
            ${SearchTemplateHorses.fragments.horses}
          }
        }
      `,
      variables() {
        return {
          keyword: this.search
        };
      },
      skip() {
        return !this.search || this.search.length < 3;
      }
    }
  }
});
</script>
